import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import nameDialog from './dialog/name.vue';
import cityDialog from './dialog/city.vue';
import gradeDialog from './dialog/grade.vue';
import captcha from './dialog/captcha.vue';
import password from './dialog/password.vue';
import LogoutDialog from '@/views/user-center/dialog/logout.vue';
import resetDialog from '@/views/user-center/dialog/reset.vue';
import PageTitle from '@/components/page-title.vue';
import { getUserInfoDetail as _getUserInfoDetail, getAreaGradeInfo as _getAreaGradeInfo, userInfoComplete, ajaxUpdateSendVerifyCode, ajaxUpdatePwd, ajaxTokenValidateVerifyCode } from '@/api/login';
import { captchaSlideConfig } from './utils/func';
import { slideAsync } from '@/utils/behaviorTest';
export default {
  name: 'UserCenter',
  components: {
    LogoutDialog: LogoutDialog,
    resetDialog: resetDialog,
    PageTitle: PageTitle
  },
  data: function data() {
    return {
      showLogoutDialog: false,
      resetAccountDialog: false,
      userInfo: {},
      // 接口返回的
      verifyCode: '' // 验证码(后端返回的新的code)

    };
  },
  computed: {
    proviceName: function proviceName() {
      // 直辖市不显示名称
      if ([28, 29, 30, 31].includes(this.userInfo.province)) {
        return '';
      }

      return this.userInfo.provinceName;
    }
  },
  mounted: function mounted() {
    this.getUserInfoDetail();
    this.getAreaGradeInfo();
  },
  methods: {
    getUserInfoDetail: function getUserInfoDetail() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userInfo, params, _yield$_getUserInfoDe, status, data, name, avaterUrl;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userInfo = JSON.parse(localStorage.getItem('userInfo'));
                params = {
                  uid: userInfo.uid
                };
                _context.next = 4;
                return _getUserInfoDetail(params);

              case 4:
                _yield$_getUserInfoDe = _context.sent;
                status = _yield$_getUserInfoDe.status;
                data = _yield$_getUserInfoDe.data;

                if (!(status !== 1)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                _this.userInfo = data;
                console.log('this.userInfo', _this.userInfo);
                localStorage.setItem('userInfo', JSON.stringify(data)); // 将用户名存于vuex

                name = data.name, avaterUrl = data.avaterUrl;

                _this.$store.dispatch('setUsername', name);

                _this.$store.dispatch('setUserAvatar', avaterUrl);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getAreaGradeInfo: function getAreaGradeInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_getAreaGradeI, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _getAreaGradeInfo();

              case 2:
                _yield$_getAreaGradeI = _context2.sent;
                status = _yield$_getAreaGradeI.status;
                data = _yield$_getAreaGradeI.data;

                if (!(status !== 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                _this2.AreaGradeInfo = data;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    changeDialog: function changeDialog(type) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var componentsMap, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                componentsMap = {
                  name: nameDialog,
                  city: cityDialog,
                  grade: gradeDialog,
                  nameTitle: '昵称',
                  cityTitle: '选择城市',
                  gradeTitle: '选择年级'
                };
                _context3.next = 3;
                return _this3.$showModal(componentsMap[type], {
                  userInfo: _this3.userInfo,
                  areaGradeInfo: _this3.AreaGradeInfo
                }, {
                  title: componentsMap[type + 'Title'],
                  noFooter: true,
                  width: '560px',
                  customClass: 'user-info-dialog-' + type
                });

              case 3:
                res = _context3.sent;

                if (res) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                console.log(res);
                _context3.next = 9;
                return _this3.setUserInfoComplete(res);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    setUserInfoComplete: function setUserInfoComplete(res) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, _yield$userInfoComple, status;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = _objectSpread(_objectSpread({}, _this4.userInfo), res);
                _context4.next = 3;
                return userInfoComplete(params);

              case 3:
                _yield$userInfoComple = _context4.sent;
                status = _yield$userInfoComple.status;

                if (!(status !== 1)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return");

              case 7:
                _this4.getUserInfoDetail();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    logOut: function logOut() {
      this.showLogoutDialog = true; // this.$messageBox.confirm('确认退出当前账号登录？', '退出登录', {
      //   center: true,
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消'
      // }).then(() => {
      //   toLogin()
      // }).catch(() => {})
    },
    // 参数 调修改密码的接口
    changePwdOK: function changePwdOK(pwdMd5) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var uid, _yield$ajaxUpdatePwd, status;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                uid = _this5.userInfo.uid;
                _context5.next = 3;
                return ajaxUpdatePwd({
                  uid: uid,
                  verifyCode: _this5.verifyCode,
                  password: pwdMd5
                });

              case 3:
                _yield$ajaxUpdatePwd = _context5.sent;
                status = _yield$ajaxUpdatePwd.status;

                if (!(status === 1)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", true);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 修改密码
    changePwd: function changePwd() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.$showModal(password, {
                  userInfo: _this6.userInfo,
                  callback: _this6.changePwdOK
                }, {
                  title: '设置新密码',
                  noFooter: true,
                  width: '560px',
                  customClass: 'user-info-dialog-pwd'
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取验证码
    getCaptcha: function getCaptcha() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var config, mmvToken, params, _yield$ajaxUpdateSend, status, res;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                config = captchaSlideConfig();
                _context7.next = 3;
                return slideAsync(config);

              case 3:
                mmvToken = _context7.sent;
                params = {}; // mobile: this.phone

                _context7.next = 7;
                return ajaxUpdateSendVerifyCode(params, mmvToken);

              case 7:
                _yield$ajaxUpdateSend = _context7.sent;
                status = _yield$ajaxUpdateSend.status;

                if (!(status === 1)) {
                  _context7.next = 17;
                  break;
                }

                _context7.next = 12;
                return _this7.$showModal(captcha, {
                  phone: _this7.userInfo.phone,
                  // this.userInfo 手机号
                  sendVerifyCode: ajaxUpdateSendVerifyCode,
                  // 发送验证码接口
                  loginVerifyCode: ajaxTokenValidateVerifyCode // 验证验证码接口

                }, {
                  title: '请输入验证码',
                  noFooter: true,
                  width: '560px',
                  customClass: 'user-info-dialog-cap'
                });

              case 12:
                res = _context7.sent;

                if (res) {
                  _context7.next = 15;
                  break;
                }

                return _context7.abrupt("return");

              case 15:
                // 验证码正确跳转改密码
                _this7.verifyCode = res === null || res === void 0 ? void 0 : res.data.newCode;

                _this7.changePwd();

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    resetAccount: function resetAccount() {
      this.resetAccountDialog = true;
    },
    goBack: function goBack() {
      this.$router.push({
        path: '/'
      });
    }
  }
};